import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import { ModalExt, Severity } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { Button } from "semantic-ui-react";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { apolloClient, ENT_DELETE, EntityDescriptor, Utils } from "@crispico/foundation-react";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { CrudGlobalSettings } from "@crispico/foundation-react/entity_crud/CrudGlobalSettings";
import gql from "graphql-tag";
import _ from "lodash";
import { createTestids } from "@famiprog-foundation/tests-are-demo";
import { Scriptable, ScriptableContainer } from "@famiprog-foundation/scriptable-ui";

type DeleteActionLocalState = AbstractActionLocalState & {
    confirmDeleteEntity: boolean,
    selection: (string | number)[]
}

export const deleteActionTestIds = createTestids("DeleteAction", {
    modalHeaderContent: ""
});

export class DeleteAction extends AbstractAction<AbstractActionProps, DeleteActionLocalState> {

    icon = "remove";
    label = _msg("entityCrud.table.delete");

    constructor(props: AbstractActionProps) {
        super(props);
        this.state = { confirmDeleteEntity: false, selection: [] };
    }

    isVisible(param: IActionParam) {
        if (param.selection.length !== 1 || typeof param.selection[0] !== "string") {
            return false;
        }
        const entityName = this.getEntityName(param.selection[0]);
        return entityName === "Mission2" || entityName === "Task" || entityName === "MissionEvent2";
    }

    async run(param: IActionParamForRun) {
        this.setState({ confirmDeleteEntity: true, selection: param.selection });
    }

    protected getDeleteOperationName(entityDescriptorName: string) {
        return `${_.lowerFirst(entityDescriptorName)}Service_deleteById(id: $id)`;
    }

    protected getGraphQlIdType(entityDescriptor: EntityDescriptor) {
        return entityDescriptor && entityDescriptor.graphQlIdType ? entityDescriptor.graphQlIdType : CrudGlobalSettings.INSTANCE.defaultGraphQlIdType;
    }

    protected async deleteEntity(entityDescriptor: EntityDescriptor, id: number) {
        const permission = Utils.pipeJoin([ENT_DELETE, entityDescriptor.name]);
        if (!AppMetaTempGlobals.appMetaInstance.hasPermission(permission, true)) {
            return;
        }

        const removeOperationName = this.getDeleteOperationName(entityDescriptor.name);
        const removeMutation = gql(`mutation deleteEntity($id: ${this.getGraphQlIdType(entityDescriptor)}){${removeOperationName}}`);

        await apolloClient.mutate({ mutation: removeMutation, variables: { id } });
    }

    render() {
        if (this.state.selection.length === 0) {
            return <></>;
        }

        const entity = this.props.getEntityAt(this.state.selection[0]);
        const entityDescriptor = entityDescriptors[this.getEntityName(this.state.selection[0])];

        return this.state.confirmDeleteEntity && entity && entityDescriptor ?
            <ScriptableContainer id="DeleteActionModal">
                <ModalExt
                    severity={Severity.INFO}
                    open={this.state.confirmDeleteEntity}
                    header={<div data-testid={deleteActionTestIds.modalHeaderContent}>{_msg("dto_crud.deleteConfirmation.header", entity.id, entityDescriptor.name)}</div>}
                    content={_msg("dto_crud.deleteConfirmation")}
                    onClose={() => this.setState({ confirmDeleteEntity: false })}
                    actions={[
                        <Scriptable id="closeButton" onClick={() => this.setState({ confirmDeleteEntity: false })}>
                            {scriptable => <Button key="close" onClick={() => scriptable.proxy.onClick()}>{_msg("general.cancel")}</Button>}
                        </Scriptable>,
                        <Scriptable id="okButton" onClick={async () => {
                            if (!entity) { return; }
                            await this.deleteEntity(entityDescriptor, entity.id);
                            this.setState({ confirmDeleteEntity: false });
                        }}>
                            {scriptable => <Button key="ok" primary onClick={() => scriptable.proxy.onClick()}>{_msg("general.ok")}</Button>}
                        </Scriptable>
                    ]}
                />
            </ScriptableContainer> :
            <></>
    }

}